import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12.7759 20.8873H7.77592C6.77176 20.8873 5.95773 20.0733 5.95773 19.0691V7.70551C5.95773 6.70136 6.77176 5.88733 7.77592 5.88733H19.1396C20.1437 5.88733 20.9577 6.70136 20.9577 7.70551V12.7055M2.95773 17.8873V4.95629C2.95773 3.81364 3.88404 2.88733 5.0267 2.88733H17.9577M5.95773 17.8873L8.36386 15.4009C9.02656 14.7161 10.101 14.7161 10.7637 15.4009L12.9577 17.6681M15.9577 18.6373H21.4577M18.7077 15.8873V21.3873M16.25 13.25C17.3546 13.25 18.25 12.3546 18.25 11.25C18.25 10.1454 17.3546 9.25 16.25 9.25C15.1454 9.25 14.25 10.1454 14.25 11.25C14.25 12.3546 15.1454 13.25 16.25 13.25Z",
      stroke: "var(--icon-color, #28373c)",
      "stroke-width": "var(--icon-stroke-width, 1.5)",
      "stroke-linecap": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }